import { Box } from '@mui/material';
import DateRangePickerInput from 'components/FormCreatorComponent/inputs/DateRangePickerInput';
import { fieldType } from 'components/FormCreatorComponent/types';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import {
	getBeneficiaryDatesRange,
	setBeneficiaryDatesRange,
} from 'state/reducers/dashboard.reducer';
import { selectTranslations } from 'state/reducers/translation.reducers';

export const BeneficiaryDateFilter = () => {
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const datesRange = useAppSelector(getBeneficiaryDatesRange);

	return (
		<Box sx={{ width: 300, alignSelf: 'flex-start' }}>
			<DateRangePickerInput
				valid
				cField={{
					type: fieldType.dateRangePicker,
					props: {
						name: 'beneficiaryDatesRange',
						label: t('page.pendingRequests.field.createdAt'),
						value: datesRange,
					},
				}}
				initialValidation={{}}
				sendSelectionToParent={(value) => dispatch(setBeneficiaryDatesRange(value))}
			/>
		</Box>
	);
};
